import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import {
  SdkErrorResponse,
  pushErrorFromAPI,
  pushSuccess,
} from 'src/utilities/notifications';
import { IErrorResponse } from 'src/utilities/shared-types';
import {
  CreateReportRequest,
  createReport,
} from 'src/components/enterprise/features/Reporting/CreateReportsPage/api/createReportApi';

export type UseCreateReportProps = {
  corpId: string;
};

export type UseCreateReportReturn = {
  submitCreateReport: (reportData: CreateReportRequest) => Promise<void>;
};

export const useCreateReport = ({
  corpId,
}: UseCreateReportProps): UseCreateReportReturn => {
  const { push } = useHistory();

  const submitCreateReport = useCallback(
    async (reportData: CreateReportRequest): Promise<void> => {
      try {
        await createReport(corpId, reportData);
        pushSuccess('Report has been created successfully.');
        push(`/corporate/enterprise/${corpId}/reports`);
      } catch (error) {
        pushErrorFromAPI(error as IErrorResponse | SdkErrorResponse, {
          fallbackMessage:
            'There was a problem creating the report. Try again.',
        });
      }
    },
    [corpId, push]
  );

  return {
    submitCreateReport,
  };
};
